import { formatPercent } from '@/utils/stringFormatters'
import { TONE_COLORS, percentageTone } from './metrics'

interface PercentTextProps {
  value: number | null | undefined
}

/**
 * A success rate, coloured by how healthy it is.
 *
 * A plain inline span rather than Texto: these sit in right-aligned table
 * cells, and a block-level element fills the cell and takes its own alignment
 * with it, stranding the number on the left.
 */
export function PercentText({ value }: PercentTextProps) {
  const tone = percentageTone(value)
  return (
    <span
      style={{ fontWeight: 700, color: tone ? TONE_COLORS[tone] : undefined }}
    >
      {formatPercent(value)}
    </span>
  )
}
